import Box from '@mui/material/Box'
import ApproveClientFormTemplate from '../../../components/5templates/ApproveClientFormTemplate'

const ApproveClientForm = () => {
    return (
        <Box sx={{ marginLeft: '60px', padding: '20px', width: '100%' }}>
            <ApproveClientFormTemplate />
        </Box>
    )
}

export default ApproveClientForm
